import { areApprovalsEnabled } from '@/ui/helpers/featureHelper';
import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';

export function guardApprovalsFeatureToggle(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!areApprovalsEnabled()) {
    const redirectTo: NamedLocation = { name: 'home' };
    next(redirectTo);

    return;
  }

  next();
}
